export default {
  label: {
    "&.MuiInputLabel-root": {
      position: "static",
      display: "inline-flex",
      gap: "1ex",
      mb: "calc(0.5 * var(--rhythm))",
      transform: "none",
    },
  },
  input: {
    width: "100%",
    "&.MuiInputBase-root": {
      "&::placeholder": {
        opacity: 1,
      },
      boxShadow: "0 0 var(--width-10) 0 var(--color-grey-light)",
    },
  },
  error: {},
};
